import React, {ReactNode} from 'react';
import {DataPoint} from '../../types';
import {Property} from 'csstype';
import {ScaleLinear, ScaleTime} from 'd3-scale';
import {Popover} from 'react-tiny-popover';
import {PopoverBackground} from '../elements/popovers';

export interface PointSeriesProps<T extends DataPoint> {
  data: T[];
  color: Property.Color;
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  radius: number;
  popContent: (d: T) => ReactNode;
  isEmptyCore?: boolean;
}

export default class PointSeries<T extends DataPoint> extends React.Component<PointSeriesProps<T>> {
  render() {
    const {data, color, xScale, yScale, radius, popContent, isEmptyCore} = this.props;

    return (
      <g>
        {data.map((p, i) => (
          <PoppingCircle
            popContent={popContent(p)}
            key={i}
            cx={xScale(p.date)!}
            cy={yScale(p.value)!}
            r={radius}
            fill={color}
            isEmptyCore={isEmptyCore}
          />
        ))}
      </g>
    );
  }
}

interface PoppingCircleProps {
  popContent: ReactNode;
  cx: number;
  cy: number;
  r: number;
  fill: Property.Color;
  isEmptyCore?: boolean;
}

class PoppingCircle extends React.Component<PoppingCircleProps, {isOpen: boolean}> {
  constructor(props) {
    super(props);

    this.state = {isOpen: false};
  }

  render() {
    const {isOpen} = this.state;
    const {popContent, cx, cy, r, fill, isEmptyCore} = this.props;

    return (
      <Popover
        isOpen={isOpen}
        content={<PopoverBackground>{popContent}</PopoverBackground>}
        containerClassName="point-popover">
        <g>
          <circle cx={cx} cy={cy} r={r} fill={fill} />
          {isEmptyCore && <circle cx={cx} cy={cy} r={r * 0.6} fill="#ffffff" />}
          <circle
            onMouseOver={() => this.setState({isOpen: true})}
            onMouseOut={() => this.setState({isOpen: false})}
            cx={cx}
            cy={cy}
            r={r * 2}
            opacity={0}
          />
        </g>
      </Popover>
    );
  }
}
